export const COLOUR_FACET_SWATCHES: Record<string, string> = {
  black: '#282f43',
  blue: '#77a4b5',
  brown: '#b68d63',
  green: '#42a77b',
  grey: '#e5e5e5',
  neutral: '#c2c2c2',
  orange: '#ff6f52',
  pink: '#da63ad',
  purple: '#7c5aa6',
  red: '#e71b23',
  white: '#ffffff',
  yellow: '#ffb71b'
}

export function getColourFacetLabel(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1)
}
